import React from "react";
import styled from "styled-components";
import H2 from "../../DS/Typo/H2";
import Wrapper from "../../DS/Wrapper/Wrapper";
import bod from "../../assets/images/bod.jpg";
import InfoCard from "../InfoCard/InfoCard";
import EmailSubscribe from "../EmailSubscribe/EmailSubscribe";
import LightDivider from "../LightDivider/LightDivider";
import mark from "../../assets/images/mark.png";
const MarkImg = styled.img`
  position: absolute;
  top: 200%;
  right: 0;
  width: 110px;
`;
const BoardOfDirectorContainer = styled.div``;

const BODImg = styled.img`
  margin: 54px auto;
  max-width: 100%;
`;

const data = [
  {
    heading: "PRESIDENT, (solo term)",
    title: "Peggy Mobley",
    phone: ["334-312-3258"],
    mail: ["phmobley46@gmail.com"],
  },
  {
    heading: "Vice President, (2nd Term)",
    title: "Rex Cheatham",
    phone: ["256-565-2027"],
    mail: ["rex.rexcheatham@yahoo.com"],
  },
  {
    heading: "Treasurer, (1st Term)",
    title: "John Paul Jones",
    phone: ["251-689-1126"],
    mail: ["johnpaul.aera@gmail.com"],
  },
  {
    heading: "Secretary, (2nd Term)",
    title: "Susan Helms",
    phone: ["334-347-7350", "334-389-0622"],
    mail: ["shelms4@roadrunner.com"],
  },
  {
    heading: "Member At Large, Leg. (1st Term)",
    title: "Debbie Landers Martin",
    phone: ["256-390-6185"],
    mail: ["debbielscott@bellsouth.net"],
  },
  {
    heading: "Member At Large, Mbr. (2nd Term)",
    title: "Vivian Crosby",
    phone: ["334-309-6209"],
    mail: ["vivian.crosby@att.net"],
  },
  {
    heading: "Immediate Past Pres. (solo term)",
    title: "Sarah Horton",
    phone: ["251-554-1120"],
    mail: ["hort4032@bellsouth.net"],
  },
  {
    heading: "Parliamentarian, (Solo Term)",
    title: "Melba Wiegand",
    phone: ["205-746-5288"],
    mail: ["melbawiegand@gmail.com"],
  },
  {
    heading: "Board of Control",
    title: "Dave Wales, TRS -PEEHIP",
    phone: ["334-517-7000"],
    mail: ["dave.wales@rsa-al.gov"],
  },
  {
    heading: "AEA-AERA Coordinator",
    title: "Theron Stokes",
    phone: ["334-834-9790"],
    mail: ["theron.stokes@alaedu.org"],
  },
  {
    heading: "District 1 Director, (1st Term)",
    title: "Dr. Delaina Greene",
    phone: ["256-710-0866"],
    mail: ["delainagreene@gmail.com"],
  },
  {
    heading: "District 2 Director, (2nd Term)",
    title: "Dr. Toni McGriff",
    phone: ["865-696-5363"],
    mail: ["tonimcgriff@gmail.com"],
  },
  {
    heading: "District 3 Director, (1st Term)",
    title: "Icie Wriley",
    phone: ["205-662-4766"],
    mail: ["wriley3@hotmail.com"],
  },
  {
    heading: "District 4 Director, (2nd Term)",
    title: "Brenda Lockhart",
    phone: ["205-841-3312", "205-601-0248 (Cell)"],
    mail: ["brnlock8@aol.com"],
  },
  {
    heading: "District 5 Director, (2nd Term)",
    title: "Pam Hendrick",
    phone: ["334-559-0462"],
    mail: ["pamgregory@charter.net"],
  },
  {
    heading: "District 6 Director, (1st Term)",
    title: "Alvin Owens",
    phone: ["334-412-4829 (Cell)", "334-875-6253"],
    mail: ["alvinwowens@att.net"],
  },
  {
    heading: "District 7 Director, (1st Term)",
    title: "Wayne Boswell",
    phone: ["334-382-5002", "334-437-0155 (Cell)"],
    mail: ["r.wayneboswell25@gmail.com"],
  },
  {
    heading: "District 8 Director, (2nd Term)",
    title: "Susan Fant",
    phone: ["251-367-1121"],
    mail: ["superli52@aol.com"],
  },
  {
    heading: "District 9 Director, (2nd Term)",
    title: "Brenda Curry",
    phone: ["334-791-8303"],
    mail: ["nalebmc@yahoo.com"],
  },
  {
    heading: "District 10 Director, (1st Term)",
    title: "Dr. Jim Jolly",
    phone: ["205-561-8210"],
    mail: ["jimjolly95@gmail.com"],
  },
  {
    heading: "Executive Director",
    title: "Wendy Lang",
    phone: ["334-262-4177", "800-537-6867"],
    mail: ["wlang@aerainc.org"],
  }
];

const BoardOfDirector = () => {
  return (
    <BoardOfDirectorContainer>
      <Wrapper
        type="m"
        display="flex"
        alignItems="center"
        flexDirection="column"
      >
        <H2
          style={{
            textAlign: "center",
            maxWidth: 936,
          }}
        >
          Alabama Education Retirees Association
          District Map
        </H2>
        <BODImg
          src={bod}
          alt="board of director"
        />
      </Wrapper>
      <Wrapper
        type="m"
        display="flex"
        style={{
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        {data.map((d, index) => {
          return (
            <InfoCard
              key={index}
              heading={d.heading}
              title={d.title}
              phone={d.phone}
              mail={d.mail}
            />
          );
        })}
      </Wrapper>
      <LightDivider marginTop="60px" />
      <Wrapper
        type="m"
        marginTop="50px"
      ></Wrapper>
      <EmailSubscribe />
      <Wrapper
        type="m"
        marginTop="50px"
      ></Wrapper>
      <MarkImg src={mark} alt="AERA" />
    </BoardOfDirectorContainer>
  );
};

export default BoardOfDirector;
